export default [{
  path: '/graphicType',
  name: 'graphicType',
  meta: {
    layout: 'main'
  },
  component: () => import('@/views/graphicType/index')
}]
